import { GearArrowIcon, GearIcon, LogoutIcon, UserGroupIcon } from '@eleveo/icons-react';
import { TFunction } from 'i18next';
import React from 'react';

import { PATH_MY_CONFIGURATIONS } from './routes';
import { ReactComponent as QMIcon } from '../assets/icons/quality-management.svg';
import { ReactComponent as WFMIcon } from '../assets/icons/workforce-management.svg';
import { FooterLinkType } from '../components/layout/manageAccount/ManageAccountDropdown';
import { TEST_IDS } from '../constants/dataTestIds';
import { APPLICATIONS, defaultConfiguration } from '../constants/integrationConstants';
import { Authenticated } from '../utils/keycloakUtils';
import { NavItemType } from '../utils/navigationUtils';

export const getNavItems = (t: TFunction): NavItemType[] => [
  {
    url: `/${PATH_MY_CONFIGURATIONS}`,
    text: t('layout.navigation.myConfigurations'),
    requiredPermissions: [],
    icon: <GearArrowIcon />,
    testId: TEST_IDS.myIntegrationsNavItem,
  },
];

export const getAppSwitcherLinks = (
  config: typeof defaultConfiguration,
  appSwitcherApps: string[] | undefined,
  t: TFunction
): FooterLinkType[] => {
  if (!config) {
    return [];
  }

  const { workforceManagementUrl, qualityManagementUrl, userManagementUrl } = config;

  return [
    {
      to: workforceManagementUrl,
      text: t('applications.workforceManagement'),
      icon: <WFMIcon />,
      testId: TEST_IDS.workforceManagementNavItem,
      name: APPLICATIONS.wfm,
    },
    {
      to: qualityManagementUrl,
      text: t('applications.qualityManagement'),
      icon: <QMIcon />,
      testId: TEST_IDS.qualityManagementNavItem,
      name: APPLICATIONS.qm,
    },
    {
      to: userManagementUrl,
      text: t('applications.userManagement'),
      icon: <UserGroupIcon />,
      testId: TEST_IDS.userManagementNavItem,
      name: APPLICATIONS.um,
    },
  ].filter((link) => appSwitcherApps && appSwitcherApps.includes(link.name));
};

export const getUserManagementLinks = (
  auth: Authenticated,
  config: typeof defaultConfiguration,
  t: TFunction
): FooterLinkType[] => {
  if (!auth) {
    return [];
  }

  if (!config) {
    return [];
  }

  const { userProfileUrl } = config;

  return [
    {
      to: userProfileUrl,
      text: t('layout.navigation.manageAccount'),
      icon: <GearIcon />,
      testId: TEST_IDS.manageAccountNavItem,
      name: 'Create account',
    },
    {
      to: auth.logoutUrl,
      text: t('layout.navigation.signOut'),
      icon: <LogoutIcon />,
      testId: TEST_IDS.logoutNavItem,
      name: 'Sign out',
    },
  ];
};
